<template>

  <div>
    <QuestionnairePersonalityBig5
      v-if="questionnaire.key === 'big5-factor-markers-50-pt-BR' || questionnaire.key === 'big5-factor-markers-50-en-US' || questionnaire.key === 'big5-factor-markers-50'"
      :meta="personalityMeta" />
    <QuestionnairePersonalityDiscClassic
      v-if="questionnaire.key === 'disc-classic'"
      :meta="personalityMeta"/>
  </div>

</template>

<script>
import QuestionnairePersonalityBig5 from './QuestionnairePersonalityBig5'
import QuestionnairePersonalityDiscClassic from './QuestionnairePersonalityDiscClassic'

export default {
  name: 'QuestionnairePersonality',
  components: {
    QuestionnairePersonalityBig5,
    QuestionnairePersonalityDiscClassic
  },
  props: {
    questionnaire: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    personalityMeta () {
      const object = {}
      const array = this.questionnaire.personality_meta || []
      array.forEach(val => {
        object[val.key] = val.value
      })
      return object
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Questionnaire/QuestionnairePersonality.vue